import { Address } from '@thirdweb-dev/sdk';
import { useMemo } from 'react';
import { useConfig } from '@app/config';

export function useIsHiddenPool(address: Address | undefined) {
  const config = useConfig();

  return useMemo(() => {
    return config?.CONTENT.hiddenPools.some(
      (item: string) => item.toLowerCase() === address?.toLowerCase()
    );
  }, [address, config]);
}
